// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.48959 16.5104C7.56978 19.5906 12.4258 19.8126 15.762 17.1765L21.1064 22.5209L22.5206 21.1067L17.1763 15.7623C19.8126 12.4261 19.5907 7.56987 16.5104 4.48959C13.191 1.17014 7.80905 1.17014 4.48959 4.48959C1.17014 7.80905 1.17014 13.191 4.48959 16.5104ZM6.5 9.5L14.5 9.5V11.5H6.5V9.5Z"}}]};

const ZoomOutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'zoom-out-filled',
    ref,
    icon: element,
  },
));

ZoomOutFilledIcon.displayName = 'ZoomOutFilledIcon';

export default ZoomOutFilledIcon;
